// ============================================
// OLA Cosmetics: the free gift
//
// One Velvet Puff rides along with every order, added on its own so she never has to
// find it. Buying a second one is a normal paid purchase.
//
// This file only ever ADDS a line. It cannot set a price to zero, so the discount in
// the Shopify admin is what actually makes the gift free. Because a missing or expired
// discount would quietly charge every customer an extra 59 shekels, the sync below
// checks the cart total after adding and pulls the gift straight back out if the
// discount did not land. The store can never charge for the gift, whatever the admin
// looks like on any given day.
// ============================================
(function () {
  'use strict';

  var GIFT_PROP   = '_gift';
  var SUSPEND_KEY = 'ola_gift_suspended';

  var busy = false;

  function config() {
    return window.OLA_GIFT || { enabled: false };
  }

  // Marked lines are recognised by the property alone, not by the variant. When the
  // campaign ends the chosen product changes or the switch goes off, and yesterday's
  // gift still has to be cleanable out of a cart that is sitting in someone's browser.
  function isGift(item) {
    return item.properties && item.properties[GIFT_PROP] === 'true';
  }

  // Everything she chose herself. A gift line never counts toward this, otherwise the
  // gift would keep its own presence alive after she emptied the cart.
  function paidCount(cart) {
    return cart.items.reduce(function (n, it) {
      return isGift(it) ? n : n + it.quantity;
    }, 0);
  }

  // Did she get a unit of this product for nothing? Asked of the whole cart rather than
  // of one line, because Shopify decides which line a discount lands on and it does not
  // always pick ours.
  function someUnitIsFree(cart, variantId) {
    return cart.items.some(function (it) {
      return it.variant_id === variantId && it.final_line_price === 0;
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function setQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function addGift(variantId) {
    var props = {};
    props[GIFT_PROP] = 'true';
    /* NOTE, measured and left as it is on purpose.
     *
     * This add makes Shopify emit `product_added_to_cart`, and the Google and Meta
     * channel pixels turn that into an AddToCart worth 0. Every click on a buy button
     * therefore reports two adds: the real one and the gift.
     *
     *   add_to_cart  value 179  ILS
     *   add_to_cart  value 0    ILS
     *
     * Moving this to /cart/update.js was tried and measured: the zero-value event
     * still fires, because Shopify reports a line appearing in the cart regardless of
     * which endpoint put it there. It also costs the _gift property, which is what
     * lets a gift from an ended campaign still be recognised and cleaned out of a
     * cart sitting in someone's browser. So the endpoint stays, and the double count
     * is dealt with where it can be: a Meta custom conversion filtered on value > 0,
     * and a GA4 funnel built on add_to_cart with value > 0.
     */
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('gift add rejected');   // sold out, most likely
      return r.json();
    });
  }

  // Two different events, because two different things listen.
  // `cart:updated` is what the header badge and the totals watch. The drawer redraws its
  // item list only on `cart:refresh` (see sections/cart-drawer.liquid), so announcing the
  // first one alone left the gift in the cart but invisible on screen.
  // No loop: cart-drawer's own refresh ends by firing `cart:updated`, which brings us
  // back here, but by then the gift is already correct and sync returns without
  // announcing again.
  function onCartPage() {
    return /^\/cart\/?$/.test(window.location.pathname);
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // The /cart page is rendered by the server and nothing on it listens for a cart
    // change, so a gift added a second after it loaded sits in her cart but is missing
    // from the page in front of her. That is what makes the feature look dead: the
    // product page's add button navigates here rather than opening the drawer.
    // Re-render the section rather than reloading, so her scroll position survives.
    // This cannot loop: once the gift is correct, sync stops calling announce.
    if (onCartPage()) {
      fetch('/cart?section_id=main-cart&_=' + Date.now(),
            { headers: { Accept: 'text/html' }, cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html')
                        .querySelector('.shopify-section, #MainCart, [id^="shopify-section"]');
          var live  = document.querySelector('#MainCart')
                   || document.querySelector('[id^="shopify-section"][id*="main-cart"]');
          if (fresh && live) live.replaceChildren.apply(live, Array.from(fresh.childNodes));
          else window.location.reload();
        })
        .catch(function () { window.location.reload(); });
    }
  }

  // A failed attempt is counted, not made permanent. The first version latched off for
  // the whole session, which meant a single bad moment, a discount being edited in the
  // admin for instance, silently cost that shopper her gift for as long as her tab
  // stayed open. Three tries recovers from a transient problem while still bounding the
  // add-and-remove churn if the discount is genuinely gone.
  var MAX_FAILURES = 3;

  function failures() {
    try { return parseInt(sessionStorage.getItem(SUSPEND_KEY), 10) || 0; } catch (e) { return 0; }
  }
  function suspended() {
    return failures() >= MAX_FAILURES;
  }
  function suspend() {
    try { sessionStorage.setItem(SUSPEND_KEY, String(failures() + 1)); } catch (e) { /* private mode */ }
  }
  /* A PRESENT THAT DISAPPEARS WITHOUT A WORD COSTS MORE THAN THE PRESENT.

     Both places above pull the gift line when the discount stops combining, which is what
     happens when she enters a coupon. Until now it went silently: she opened the drawer,
     saw a מתנה line, typed a code, and on the next refresh the present was simply gone. She
     then distrusts the code and the gift at once. */
  function noticeGiftRemoved() {
    try {
      document.dispatchEvent(new CustomEvent('cart:notice', {
        detail: { text: 'המתנה לא ניתנת לשילוב עם הקוד שהזנת, ולכן הוסרה מהסל.' }
      }));
    } catch (e) {}
  }

  function clearFailures() {
    try { sessionStorage.removeItem(SUSPEND_KEY); } catch (e) { /* private mode */ }
  }

  // `allowAdd` is the whole point of this file's rewrite on 19.9.2026.
  //
  // sync() used to run on every page load and, finding a cart with paid lines and no gift,
  // post /cart/add.js there and then. Shopify turns any such post into product_added_to_cart
  // and the Meta and Google channel pixels turn that into an AddToCart. So a shopper who put
  // something in her cart yesterday and today reads the FAQ page generated an add-to-cart
  // event with nobody clicking anything, in a session that can never reach checkout. Measured
  // on the live shop: cart holding one paid line, gift line deleted, FAQ page loaded, nothing
  // touched, ten seconds later fbq had fired AddToCart and the sponge was in the cart.
  //
  // That event is not recoverable revenue, it is a lie told to the ad account: it lands in
  // every "added to cart" audience and in the signal Advantage+ optimises on, and it drags
  // the funnel percentage the owner reads down for no reason.
  //
  // So CLEANING still happens everywhere, because a gift that is no longer free has to come
  // out of her cart wherever she is standing. ADDING now happens only where she is actually
  // looking at her cart or has just put something in it.
  function sync(allowAdd) {
    if (busy) return Promise.resolve();
    busy = true;

    var cfg = config();

    return getCart().then(function (cart) {
      var gift = cart.items.filter(isGift)[0];
      var paid = paidCount(cart);

      // Campaign over, or the chosen product went out of stock. Any gift still sitting
      // in a cart from before has to come out, or she reaches checkout holding a line
      // that no discount covers any more.
      if (!cfg.enabled || !cfg.variantId) {
        return gift ? setQty(gift.key, 0).then(announce) : null;
      }

      // Nothing of her own left. The gift goes with it, so the order can never be
      // a lone free item.
      if (paid === 0) {
        return gift ? setQty(gift.key, 0).then(announce) : null;
      }

      // The campaign switched to a different product while her cart was open.
      if (gift && gift.variant_id !== cfg.variantId) {
        return setQty(gift.key, 0).then(announce);
      }

      // Any line holding the gift product that we did not put there is not a gift, it is
      // a free item she found. Hiding it from the collection grid was not enough: the
      // product page answers on its own URL and it still turns up in search. This runs
      // before the "gift is already fine" branch below, or a correct gift would let a
      // stray sit beside it untouched. One unit per order, whichever way she got here.
      var strays = cart.items.filter(function (it) {
        return it.variant_id === cfg.variantId && !isGift(it);
      });
      if (strays.length) {
        return setQty(strays[0].key, 0).then(announce);
      }

      // She has items and the gift is already sitting there at the right quantity.
      // Being present is not enough: it has to still be FREE. A discount code entered
      // after the gift went in can take the gift's own discount with it, when the two
      // discounts are not set to combine in the admin. Checking only at add time left
      // her holding a 59 shekel line she never chose.
      //
      // The test is "is some unit of this product free", not "is THIS line free",
      // because when she also buys one herself Shopify may put the discount on her
      // line instead of ours. Either way she got one for nothing.
      if (gift && gift.quantity === 1) {
        if (!someUnitIsFree(cart, cfg.variantId)) {
          return setQty(gift.key, 0).then(function () {
            suspend();
            noticeGiftRemoved();
            announce();
          });
        }
        /* THE ONE PLACE THAT PROVES EVERYTHING IS FINE, and it used to prove nothing.

           clearFailures() was reachable only from the add path, and the add path is the
           thing the suspension skips: three counted failures and `if (suspended()) return`
           below returned before any add was attempted, so the line that would have cleared
           the counter could never run again. The counter lives in sessionStorage, so the
           present stopped being given for the rest of the visit. Here the gift is sitting
           in the cart and it is free, which is the definition of working. */
        clearFailures();
        return null;
      }

      // A stray quantity, from a double add or a restored cart.
      if (gift && gift.quantity !== 1) return setQty(gift.key, 1).then(announce);

      if (suspended()) return null;
      if (!allowAdd) return null;

      // The old test was "did the cart total move", and it could never be true: the gift
      // product's own price is 0.00, so no discount has to land for the total to stay put
      // and the guard never fired once. The line's own price is the honest test, and it
      // still catches the case the guard was written for, which is a discount that stops
      // combining and turns the present into a 59 shekel charge.
      /* The .catch on THIS chain, not on the whole pass. The outer one below counted a
         failure for any rejection in the function, including a /cart.js read that failed on
         a clean-only pass where no add was even attempted: three flaky moments on a phone
         and the gift was suspended without a single add having been tried. Only a failed
         add is a reason to stop adding. */
      return addGift(cfg.variantId).then(getCart).then(function (after) {
        var added = after.items.filter(isGift)[0];
        if (added && added.final_line_price > 0) {
          return setQty(added.key, 0).then(function () {
            suspend();
            noticeGiftRemoved();
            announce();
          });
        }
        // It landed free, so whatever went wrong earlier is over.
        clearFailures();
        announce();
      }).catch(function () {
        // A gift that cannot be added is not a reason to break a real purchase. It is a
        // reason to stop trying: the add throws when the gift is sold out, and without
        // counting that the failure repeated on every page load for the rest of her visit.
        suspend();
      });
    }).catch(function () {
      // Reading the cart failed, or something unrelated did. Nothing was added and nothing
      // was charged, so there is nothing to suspend.
    }).then(function () {
      busy = false;
    });
  }

  // Shopify's own checkout is server-side, so the cart is the last place we can act.

  // A cart change from anywhere in the theme. Clean only: this fires after our own add too,
  // and it fires on a background refresh where no one asked for anything.
  document.addEventListener('cart:updated', function () {
    setTimeout(function () { sync(false); }, 0);
  });

  // She put something in her cart. This is the one moment the gift is supposed to appear.
  document.addEventListener('cart:item-added', function () {
    setTimeout(function () { sync(true); }, 0);
  });

  // She opened the cart drawer. Her cart may have arrived from another device through Shop
  // cart sync, or from a visit before the campaign started, so the gift is owed to her and
  // she is looking straight at the place it goes.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-cart-toggle]')) {
      setTimeout(function () { sync(true); }, 120);
    }
  }, true);

  // On load, clean everywhere and add only on the cart page, which is the other place she is
  // looking at her cart. Every other page cleans and stays quiet.
  function boot() { sync(onCartPage()); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Kept for the console and for anything in the theme that wants to force a pass. Adding is
  // opt in here too, so a stray call cannot put an event in the ad account.
  window.OLA_Gift = {
    sync: function (allowAdd) { return sync(allowAdd === true); },
    config: config
  };
})();
